import { EffectCallback, RefObject, useEffect, useState } from 'react'

const useWhenVisible = (
  effect: EffectCallback,
  element: RefObject<HTMLElement>,
  dependencies: any[],
): void => {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (isActive) effect()
  }, [...dependencies, isActive])

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsActive(entry.isIntersecting)
    })

    if (element.current) {
      observer.observe(element.current)
    }
    return () => {
      if (element.current) {
        observer.unobserve(element.current)
      }
    }
  }, [element.current])
}

export default useWhenVisible
